import React from 'react';

import { classNames } from '../../utils/style';
import { Image } from '../Image';
import { ImageProps } from '../Image/types';

export const BlogAskADemoImage = ({ className, ...props }: ImageProps) => {
  return (
    <Image
      className={classNames('BlogAskADemoImage', className)}
      {...props}
      sizes={['(max-width: 1280) 100vw, 768px, 360px']}
    />
  );
};
